import React, { useState, useEffect, useRef, useCallback } from "react";
import config from "../../Config";
import axios from "axios";
import LibraryMenu from './LibraryMenu';
import book from '../../assets/images/book.png';
import { NavLink, useParams } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import ShowStaff from "../Shared/ShowStaff";
import RightsCheck from "../General/RightsCheck";
import ShowStudentByRag from "../Shared/ShowStudentByRag";

function IssueBook(props) {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);

    const [Books, setBooks] = useState('');
    const [CurrentStatus, setCurrentStatus] = useState('');
    const [User_Code, setUser_Code] = useState('');
    const [selectedMember, setSelectedMember] = useState(null);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(0);

    const [submitted, setSubmitted] = useState(false);
    const [userType, setUserType] = useState('');

    const searchTimerRef = useRef(null);

    const selectStyles = {
        control: (provided) => ({
            ...provided,
            width: '100%',
        }),
    };

    const handleRadioChange = (event) => {
        setUserType(event.target.value);
        setUser_Code('');
        setSelectedMember(null);
        setSelectedEmployeeId(0);
        setSubmitted(false);
    };

    const loadStudentOptions = useCallback((inputValue, callback) => {
        const query = (inputValue || '').trim();
        if (query.length < 2) {
            callback([]);
            return;
        }

        if (searchTimerRef.current) {
            clearTimeout(searchTimerRef.current);
        }

        searchTimerRef.current = setTimeout(() => {
            axios({
                method: 'post',
                url: config.base_url + 'Library/SearchStudentsForIssue',
                headers: { 'Content-Type': 'application/json' },
                data: {
                    AccessKey: AccessKey,
                    UserID: UserID,
                    MemberType: MemberType,
                    pageSize: 40,
                    Keywords: query,
                    Status_Type_Id: 1,
                },
            })
                .then(function (response) {
                    if (response.data.status_code === 1 && response.data.ListofRecords) {
                        callback(
                            response.data.ListofRecords.map((item) => ({
                                value: item.Registration_No,
                                label: `${item.Student_Name} (${item.Registration_No})${
                                    item.Class_Name ? ' — ' + item.Class_Name : ''
                                }${item.Section_Name ? ' / ' + item.Section_Name : ''}`,
                                studentId: item.Student_ID,
                            }))
                        );
                    } else {
                        callback([]);
                    }
                })
                .catch(function () {
                    callback([]);
                });
        }, 350);
    }, [AccessKey, UserID, MemberType]);

    const loadStaffOptions = useCallback((inputValue, callback) => {
        const query = (inputValue || '').trim();
        if (query.length < 2) {
            callback([]);
            return;
        }

        if (searchTimerRef.current) {
            clearTimeout(searchTimerRef.current);
        }

        searchTimerRef.current = setTimeout(() => {
            axios({
                method: 'post',
                url: config.base_url + 'Payroll/SearchEmployees',
                headers: { 'Content-Type': 'application/json' },
                data: {
                    AccessKey: AccessKey,
                    UserID: UserID,
                    MemberType: MemberType,
                    pageNo: 1,
                    pageSize: 40,
                    Keywords: query,
                    IS_Resigned: false,
                    SchoolID: 1,
                    OrderBy: 'Name',
                },
            })
                .then(function (response) {
                    if (response.data.status_code === 1 && response.data.ListofRecords) {
                        callback(
                            response.data.ListofRecords.map((item) => ({
                                value: item.Code,
                                label: `${item.Name} (${item.Code})`,
                                employeeId: item.ID,
                            }))
                        );
                    } else {
                        callback([]);
                    }
                })
                .catch(function () {
                    callback([]);
                });
        }, 350);
    }, [AccessKey, UserID, MemberType]);

    const handleMemberSelect = (option) => {
        setSelectedMember(option);
        if (option) {
            setUser_Code(option.value || '');
            setSelectedEmployeeId(option.employeeId || 0);
            setSubmitted(true);
        } else {
            setUser_Code('');
            setSelectedEmployeeId(0);
            setSubmitted(false);
        }
    };

    let navigate = useNavigate();
    let params = useParams();

    const handleIssueBook = (event) => {

        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            if (!userType) {
                toast.error('Please select Student or Staff.', {
                    position: toast.POSITION.TOP_RIGHT
                });
                setValidated(true);
                return;
            }
            if (!User_Code || User_Code.trim() === '') {
                toast.error('Please select a student or staff member.', {
                    position: toast.POSITION.TOP_RIGHT
                });
                setValidated(true);
                return;
            }
            if (CurrentStatus && CurrentStatus !== 'Available') {
                toast.error('This book is not available for issue.', {
                    position: toast.POSITION.TOP_RIGHT
                });
                setValidated(true);
                return;
            }
            setLoading(true);
            const data = {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                ID: params.id,
                Date_Of_Issue: event.target.IssueDate.value,
                Return_Date: event.target.ReturnDate.value,
                Remarks: event.target.Remarks.value,
            };

            if (userType === 'student') {
                data.Registration_No = User_Code;
            }
            else {
                data.EmployeeCode = User_Code;
            }

            var api_config = {
                method: 'post',
                url: config.base_url + 'Library/IssueBook',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            axios(api_config)
                .then(function (response) {
                    if (response.data.status_code == 1) {
                        toast.success(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        navigate('/Library/ViewLibrary');
                    }
                    else {
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                    }

                    setLoading(false);
                })
                .catch(function (error) {
                    setLoading(false);
                    toast.error('Network Error..', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                });
        }

        setValidated(true);
    };

    useEffect(() => {
        document.title = "Issue Book"
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            ID: params.id,
        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'Library/GetBookByID',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code == 1) {
                    setBooks(response.data.Book)
                    setCurrentStatus(response.data.Book.Current_Status);
                }
                else {
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
                toast.error('Network Error..', {
                    position: toast.POSITION.TOP_RIGHT
                });
            });
    }, []);

    useEffect(() => {
        return () => {
            if (searchTimerRef.current) {
                clearTimeout(searchTimerRef.current);
            }
        };
    }, []);

    return (
        <>
            <LibraryMenu />
            <ToastContainer />
            <RightsCheck/>
            <div className="container body-content">
                <div className="page-head">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><NavLink to="/Dashboard">Dashboard</NavLink></li>
                                        <li className="breadcrumb-item"><NavLink to="/Library/LibraryDashboard">Library</NavLink></li>
                                        <li className="breadcrumb-item active" aria-current="page">Issue Book</li>
                                    </ol>
                                </nav>
                                <div className="page-title">Issue Book</div>
                            </div>
                            <div className="col-md-6">
                                <div className="page-right-actions">
                                    <NavLink to="/Library/ViewLibrary" className="button button-white button-icon">
                                        Manage Library
                                        <i className="ri-file-list-2-line"></i>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-content">
                    <div className="container">
                        <div className="row align-items-center gx-2 mb-3">
                            <div className="col-md-3">
                                <div className="card">
                                    <div className="card-body text-center" style={{ minHeight: "370px" }}>
                                        <img
                                            className="img-fluid"
                                            style={{ height: "350px", objectFit: "contain" }}
                                            src={book}
                                            alt={Books.Book_Name || "Book cover"}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="card">
                                    <div className="card-body" style={{ minHeight: "370px" }}>
                                        <div className="row align-items-center">
                                            <div className="col-md-12">
                                                <div className="row align-items-center" style={{ color: "#E55C73" }}>
                                                    <div className="col-md-6">
                                                        <h3 className="m-0"><b>{Books.Book_Name}</b></h3>
                                                    </div>
                                                    <div className="col-md-6 text-right">
                                                        <p className="m-0"><b>Book No: {Books.Book_No}</b></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="info-list">
                                                    <h6>Writer Name: </h6>
                                                    <p>{Books.Writer_Name}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="info-list">
                                                    <h6>Book Price:</h6>
                                                    <p>{Books.Price}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="info-list">
                                                    <h6>Jild No. :</h6>
                                                    <p>{Books.Jild_No}</p>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="info-list">
                                                    <h6>Publisher Name: </h6>
                                                    <p>{Books.Publisher_Name}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="info-list">
                                                    <h6>No of Pages: </h6>
                                                    <p>{Books.Total_Pages}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="info-list">
                                                    <h6>Binding Type: </h6>
                                                    <p>{Books.Binding_Type}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="info-list">
                                                    <h6>Purchasing Source: </h6>
                                                    <p>{Books.Purchasing_Source}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="info-list">
                                                    <h6>Status: </h6>
                                                    <p>{Books.Current_Status}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="info-list">
                                                    <h6>Edition: </h6>
                                                    <p>{Books.Edition}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="info-list">
                                                    <h6>Enter Classification No:</h6>
                                                    <p>{Books.Category}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-center mb-3">
                            <div className="card">
                                <div className="card-body p-md-4">
                                    <div className="row align-items-end">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="" className="col-form-label">Select</label>
                                                <Form.Group className="d-flex justify-content-between">
                                                    <Form.Check
                                                        type="radio"
                                                        label='Student'
                                                        value='student'
                                                        name="userType"
                                                        checked={userType === 'student'}
                                                        onChange={handleRadioChange}
                                                    />
                                                    <Form.Check
                                                        type="radio"
                                                        label='Staff'
                                                        value='staff'
                                                        name="userType"
                                                        checked={userType === 'staff'}
                                                        onChange={handleRadioChange}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="form-group">
                                                <label htmlFor="" className="col-form-label">
                                                    {userType === 'staff' ? 'Search staff by name' : 'Search student by name'}
                                                </label>
                                                {!userType ? (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled
                                                        placeholder="Select Student or Staff first"
                                                    />
                                                ) : userType === 'student' ? (
                                                    <AsyncSelect
                                                        key="student-select"
                                                        styles={selectStyles}
                                                        cacheOptions
                                                        defaultOptions={false}
                                                        isClearable
                                                        placeholder="Type student name, father name, or reg no…"
                                                        noOptionsMessage={({ inputValue }) =>
                                                            (inputValue || '').trim().length < 2
                                                                ? 'Type at least 2 characters'
                                                                : 'No students found'
                                                        }
                                                        value={selectedMember}
                                                        onChange={handleMemberSelect}
                                                        loadOptions={loadStudentOptions}
                                                    />
                                                ) : (
                                                    <AsyncSelect
                                                        key="staff-select"
                                                        styles={selectStyles}
                                                        cacheOptions
                                                        defaultOptions={false}
                                                        isClearable
                                                        placeholder="Type staff name or employee code…"
                                                        noOptionsMessage={({ inputValue }) =>
                                                            (inputValue || '').trim().length < 2
                                                                ? 'Type at least 2 characters'
                                                                : 'No staff found'
                                                        }
                                                        value={selectedMember}
                                                        onChange={handleMemberSelect}
                                                        loadOptions={loadStaffOptions}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {submitted && User_Code.length > 0 && User_Code != null && (
                            <>
                                {userType === 'student' && <ShowStudentByRag StudentID={User_Code} />}
                                {userType === 'staff' && selectedEmployeeId > 0 && (
                                    <ShowStaff EmployeeID={selectedEmployeeId} />
                                )}
                            </>
                        )}
                        <div className="row align-items-center">
                            <Form noValidate validated={validated} onSubmit={handleIssueBook}>
                                <div className="card">
                                    <div className="card-body p-md-4">
                                        <div className="row align-items-end gy-3">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="" className="col-form-label">Issue Date</label>
                                                    <input type="date" className="form-control" name="IssueDate" required />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="" className="col-form-label">Return Date</label>
                                                    <input type="date" className="form-control" name="ReturnDate" required />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="" className="col-form-label">Remarks:</label>
                                                    <input type="text" className="form-control" name="Remarks" defaultValue={Books.Remarks} />
                                                </div>
                                            </div>
                                            <div className="col-md-2 text-end">
                                                <div className="form-group">
                                                    {
                                                        loading ?
                                                            <Spinner animation="border" role="status"></Spinner>
                                                            :
                                                            <button
                                                                type="submit"
                                                                className="button button-primary mt-3"
                                                                disabled={CurrentStatus && CurrentStatus !== 'Available'}
                                                            >
                                                                Issue Book
                                                            </button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div >
                </div >
            </div >
        </>
    );
}

export default IssueBook;
